module.exports = __webpack_public_path__ + "static/section3-65634dea45742da35249d082f759086a.png";